import { t } from 'i18next';
import {
  IContractDistributionSection,
  IContractDistributionSectionWithAmount,
} from 'services/contract/types';
import './ContractSection.scss';

interface DistributionSectionProps {
  title: string;
  section: IContractDistributionSection | IContractDistributionSectionWithAmount;
}

interface DistributionRow {
  name: string;
  value: string;
}

export const DistributionSection = ({ title, section }: DistributionSectionProps) => {
  const rows: DistributionRow[] = [
    {
      name: t('contracts.distribution.defaultShare'),
      value: `${section.defaultSharePercentage}%`,
    },
    ...(section.shares?.map((share) => ({
      name: share.salesChannelName,
      value: `${share.percent}%`,
    })) ?? []),
  ];

  return (
    <div className="contract-section contract-section--root">
      <div className="contract-section__header">
        <span className="contract-section__title">{title}</span>
      </div>

      <div className="contract-section__content">
        <div className="contract-section__content-inner">
          {rows.map((row, idx) => (
            <div key={`${row.name}-${idx}`} className="contract-section__row">
              <span className="contract-section__text">{row.name}</span>
              <span className="contract-section__value">{row.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
